import { Alert, Button, Form, FormButtonRow, FormGroup, Heading, Text, TextInput } from '@ksyos/design-system';
import { useState } from 'react';
import { getSelectedLanguage, translateKey } from '@frontend/translate';
import { practitionerEmailOnlySchema } from '../../../../common/validation/practitioner';
import { fetchJson } from '../../../store/fetch';
import { emptyValidationErrors, updateValidationErrorsForOne, validate } from '../../../utils/validation';
import { Figure } from '../../elements/figure/Figure';

export function ForgotUsername() {
    const translate = getSelectedLanguage();
    const [emailAddress, setEmailAddress] = useState('');
    const [validationErrors, setValidationErrors] = useState(emptyValidationErrors);
    const [nonRegisteredEmailError, setNonRegisteredEmailError] = useState(false);
    const [emailSent, setEmailSent] = useState(false);

    return (
        <>
            <Heading>Gebruikersnaam vergeten</Heading>
            {!emailSent && (
                <>
                    <Text>
                        Je gebruikersnaam vergeten? Geen probleem! Vul je e-mail in. Dan krijg je een e-mail met je
                        gebruikersnaam.
                    </Text>
                    {nonRegisteredEmailError && (
                        <Alert
                            appearance="warning"
                            noMargin={true}
                        >
                            Dit e-mailadres is niet bij ons bekend. Neem contact met ons op via{' '}
                            <Alert.Link
                                href="tel:+31 20 600 00 60"
                                variant="externalLink"
                            >
                                020-600 00 60
                            </Alert.Link>{' '}
                            of mail{' '}
                            <Alert.Link
                                href="mailto:info@ksyos.nl"
                                variant="externalLink"
                            >
                                info@ksyos.nl.
                            </Alert.Link>
                        </Alert>
                    )}
                    <Form
                        onSubmit={async (e) => {
                            e.preventDefault();
                            await sendEmail();
                        }}
                        submitOnEnter={true}
                    >
                        <FormGroup
                            label="E-mailadres"
                            layout="vertical"
                        >
                            <TextInput
                                error={
                                    validationErrors.get('emailAddress')
                                        ? translateKey('validation.' + validationErrors.get('emailAddress'))
                                        : undefined
                                }
                                name="emailAddress"
                                onBlur={() => validateEmail()}
                                onChange={(e) => setEmailAddress(e.target.value)}
                                type="text"
                                value={emailAddress}
                            />
                        </FormGroup>
                        <FormButtonRow>
                            <Button
                                color="secondary"
                                type="submit"
                                width="full"
                            >
                                {translate.common.next}
                            </Button>
                        </FormButtonRow>
                    </Form>
                </>
            )}
            {emailSent && (
                <>
                    <Text>
                        Een e-mail is verstuurd naar <b>{emailAddress}</b>. In de e-mail staat je gebruikersnaam.
                    </Text>
                    <Figure
                        alt=""
                        centered
                        imageUrl="/assets/images/activatie.svg"
                    />
                </>
            )}
        </>
    );

    function validateEmail() {
        setValidationErrors(
            updateValidationErrorsForOne(
                practitionerEmailOnlySchema,
                { emailAddress },
                validationErrors,
                'emailAddress'
            )
        );
    }

    async function sendEmail() {
        const { hasErrors, errors } = validate(practitionerEmailOnlySchema, { emailAddress });
        setValidationErrors(errors);

        if (!hasErrors) {
            const response = await fetchJson('/api/remindUsername', 'POST', { emailAddress });
            if (response?.status === 200 && response?.json?.emailFound) {
                setNonRegisteredEmailError(false);
                setEmailSent(true);
            } else {
                setNonRegisteredEmailError(true);
            }
        }
    }
}
